import "./Showcase.scss";

const items = [
  [
    "Resources Turn Good Moves Into Great Turns",
    "Each conquered building gives you a resource with a special ability. Use resources to recover options, hire help, strengthen warriors, or create the exact opening you need for a key conquest.",
    "resources.webp"
  ],
  [
    "Build Kingdoms, Empires, and Colonies",
    "As you expand, you are also working toward end-game scoring opportunities. Different development patterns reward different paths to prestige.",
    "scoring.webp"
  ],
  [
    "A Different Ancient Realm Every Game",
    "Buildings and resources are placed differently each game, so players must adapt to a changing map instead of following the same route every time.",
    "board-closeup.webp"
  ],
  [
    "Flags With a Second Purpose",
    "Your flags mark conquered buildings as banners, then turn into crowns when the game needs scoring or clear state tracking.",
    "flag_use.webp"
  ]
];

export default function Showcase() {
  return (
    <section className="showcase section">
      <div className="section-header">
        <span className="section-eyebrow">Beyond the core turn</span>
        <h2 className="section-title">Resources, scoring, setup, and components keep every conquest meaningful.</h2>
        <p className="section-copy">
          Kotam stays approachable because each turn is simple, but the game grows richer as players collect resources, build scoring patterns, adapt to a changing board, and use components that clearly show the state of the realm.
        </p>
      </div>

      <div className="showcase__grid">
        {items.map(([title, copy, file]) => (
          <article className="showcase__item card" key={title}>
            <div className="showcase__image" style={{ backgroundImage: `url('/assets/images/${file}')` }}>
              {/* <div className="showcase__image-label">{title}</div> */}
            </div>
            <div className="showcase__text">
              <h3>{title}</h3>
              <p>{copy}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
